import { WfHistoryDetail } from './WfHistoryDetail';

export interface WFAlertHistoryRecord {
  alertHistoryId: number;
  disasterId?: string;
  customerNumber?: string;
  buildingCode: string;
  branchCode: string;
  terminalNumber: string;
  propertyName1: string;
  propertyName2: string;
  propertyName3: string;
  propertyName4: string;
  alertsReceived: number;
  alertsCompleted: number;
  lastAlertDateTime: string | number;
}

export interface WFAlertHistoryData {
  alertHistoryRecords?: WFAlertHistoryRecord[];
}

export interface WFAlertHistorySearchResult {
  disasterId: string;
  customerNumber: string;
  buildingCode: string;
  branchCode: string;
  terminalNumber: string;
  propertyName1: string;
  propertyName2: string;
  propertyName3: string;
  propertyName4: string;
  alertsReceived: number;
  alertsCompleted: number;
  lastAlertDateTime: string;
}

export interface WFAlertHistorySearchResponse {
  alertHistory: WFAlertHistorySearchResult[];
}

export interface WFAlertHistoryDetailsResult {
  alertCategory: string;
  errorDateTime: string | number | null;
  recoveryDateTime: string | number | null;
  alertDateTime: string | number | null;
  dispatchDateTime: string | number | null;
  arrivalDateTime: string | number | null;
  completionDateTime: string | number | null;
  recoveryAlertStatus: boolean;
  alertComment: string;
  receivedContent: string;
  callerName: string;
  callerPhoneNumber: string;
  callerCategory: string;
  reportTo1Name: string;
  reportTo1Contact: string;
  reportTo1Category: string;
  reportTo2Name: string;
  reportTo2Contact: string;
  reportTo2Category: string;
  directCall: string;
}

export interface WFAlertHistoryDetailsResponse {
  alertHistoryDetail: WFAlertHistoryDetailsResult[];
}

const normalizeDate = (value: string | number | null | undefined): string => {
  if (value === null || value === undefined || value === '') return '';
  if (typeof value === 'number') {
    const millis = value < 1_000_000_000_000 ? value * 1000 : value;
    return new Date(millis).toISOString();
  }
  return value;
};

export const mapDetailsResults = (
  results: WFAlertHistoryDetailsResult[] | null
): WfHistoryDetail[] => {
  if (!results) return [];
  return results.map((item, index) => ({
    id: index + 1,
    alertCategory: item.alertCategory,
    errorDateTime: normalizeDate(item.errorDateTime),
    recoveryDateTime: normalizeDate(item.recoveryDateTime),
    alertDateTime: normalizeDate(item.alertDateTime),
    dispatchDateTime: normalizeDate(item.dispatchDateTime),
    arrivalDateTime: normalizeDate(item.arrivalDateTime),
    completionDateTime: normalizeDate(item.completionDateTime),
    recoveryAlertStatus: item.recoveryAlertStatus,
    alertComment: item.alertComment,
    receivedContent: item.receivedContent,
    callerName: item.callerName,
    callerPhoneNumber: item.callerPhoneNumber,
    callerCategory: item.callerCategory,
    reportTo1Name: item.reportTo1Name,
    reportTo1Contact: item.reportTo1Contact,
    reportTo1Category: item.reportTo1Category,
    reportTo2Name: item.reportTo2Name,
    reportTo2Contact: item.reportTo2Contact,
    reportTo2Category: item.reportTo2Category,
    directCall: item.directCall ?? '',
  }));
};

export const mapSearchResults = (
  results: WFAlertHistorySearchResult[] | null
): WFAlertHistoryData | null => {
  if (!results) return null;
  const alertHistoryRecords = results.map((item, index) => ({
    alertHistoryId: index + 1,
    disasterId: item.disasterId,
    buildingCode: item.buildingCode,
    customerNumber: item.customerNumber,
    branchCode: item.branchCode,
    terminalNumber: item.terminalNumber,
    propertyName1: item.propertyName1,
    propertyName2: item.propertyName2,
    propertyName3: item.propertyName3,
    propertyName4: item.propertyName4,
    alertsReceived: item.alertsReceived,
    alertsCompleted: item.alertsCompleted,
    lastAlertDateTime: item.lastAlertDateTime,
  }));

  return {
    alertHistoryRecords,
  };
};
